module.exports = __webpack_public_path__ + "img/icon-view.e27683ab.png";